import styled, { css } from 'styled-components'
import { ToastType } from 'interfaces/toast/toast'
import theme from 'constants/theme'
import { fluid } from 'helpers/styleHelpers/styleHelpers'

interface ToastWrapperProps {
	type: ToastType
}

export const ToastIcon = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 2.4rem;
	height: 2.4rem;
	border-radius: 100%;
	flex: 0 0 auto;
	transform: translateY(2px);
	margin-right: 1.6rem;
	background-color: ${theme.colors.primary};

	svg {
		fill: #fff;
		width: 1.2rem;
	}
`

export const Toast = styled.div<ToastWrapperProps>`
	position: relative;
	display: flex;
	width: 40rem;
	max-width: 100%;
	padding: 2rem 2.5rem;
	margin-bottom: 2rem;
	border-radius: 6px;
	background-color: #fff;
	border: 1px solid ${theme.colors.borderColor};
	color: ${theme.colors.textDark};
	text-align: left;

	${({ type }) =>
		type === 'warning' &&
		css`
			background-color: ${theme.colors.warningLight};
			border-color: ${theme.colors.warning};

			${ToastIcon} {
				background-color: ${theme.colors.warning};
			}
		`};

	${({ type }) =>
		type === 'success' &&
		css`
			background-color: ${theme.colors.greenLight};
			border-color: ${theme.colors.green};

			${ToastIcon} {
				background-color: ${theme.colors.green};
			}
		`};

	${({ type }) =>
		type === 'error' &&
		css`
			background-color: ${theme.colors.secondaryLight};
			border-color: ${theme.colors.secondary};

			${ToastIcon} {
				background-color: ${theme.colors.secondary};
			}
		`};
`
export const ToastContent = styled.div``

export const ToastTitle = styled.div`
	font-weight: 800;
	line-height: 1.6;
	margin-bottom: 0.5rem;
	${fluid('font-size', '14px', '16px')};
`

export const ToastMessage = styled.div`
	font-weight: normal;
`
